import { 
    Grid, 
    Box 
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useEffect, useState, useCallback } from "react"; // Ya no necesitas useRef aquí
import { getLegalFilesFailed } from "../../services/LegalFileService";
import DatagridCustom from "../General/DatagridCustom";
import { useToast } from "../../context/ToastContext";

export default function FailedLegalFile() {
  const { showToast } = useToast();
  const [legalFiles, setLegalFiles] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  // Estado para el modelo de filtro completo (donde viene el quickFilter)
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });

  const fetchLegalFiles = useCallback(async () => {
    setLoading(true);
    try {
      const { page, pageSize } = paginationModel;
      // Extrae el término de búsqueda del filterModel
      const searchTerm = filterModel.quickFilterValues?.join(" ") || "";

      console.log(
        `[ManagerLegalFile] Enviando solicitud: page=${
          page + 1
        }, perPage=${pageSize}, search=${searchTerm}`
      );

      const res = await getLegalFilesFailed({
        page: page + 1,
        perPage: pageSize,
        search: searchTerm, // Envía el término de búsqueda al backend
      });

      setLegalFiles(res.data.data);
      setTotal(res.data.total);
    } catch (error) {
      showToast(
        "No se pudieron cargar los expedientes. Intente de nuevo más tarde.",
      "error")
    } finally {
      setLoading(false);
    }
  }, [paginationModel, filterModel, showToast]); // Dependencias: paginationModel Y filterModel

  useEffect(() => {
    fetchLegalFiles();
  }, [paginationModel, filterModel, fetchLegalFiles]); // Dependencias de useEffect

  // Callback para manejar cambios en el modelo de filtro del DataGrid
  const handleFilterModelChange = useCallback(
    (newFilterModel) => {
      const currentSearchTerm = filterModel.quickFilterValues?.join(" ") || "";
      const newSearchTerm = newFilterModel.quickFilterValues?.join(" ") || "";

      setFilterModel(newFilterModel);

      if (currentSearchTerm !== newSearchTerm) {
        setPaginationModel((prev) => {
          if (prev.page !== 0) {
            return { ...prev, page: 0 };
          }
          return prev;
        });
      }
    },
    [filterModel]
  ); // Dependencia del filterModel para comparar cambios

  const columns = [
    { field: "file_number", headerName: "Numero de Expediente", flex: 1 },
    { field: "error_message", headerName: "Mensaje", flex: 4 },
    { field: "retry_count", headerName: "Intentos", flex: 1 },
    {
      field: "created_at",
      headerName: "Fecha de Creación",
      flex: 1,
      valueGetter: (params) => {
        const date = new Date(params);

        if (isNaN(date.getTime())) {
          return "Fecha inválida";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
    },
  ];

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

          <Box sx={{ width: "100%", overflowX: "auto" }}>
            <DatagridCustom
              rows={legalFiles}
              columns={columns}
              title="Expedientes Fallidos"
              description="Visualice los expedientes que fallaron en la consulta."
              icon={<AssignmentIcon sx={{ fontSize: 32 }} />}
              // error={globalError}
              // success={false}
              paginationModel={paginationModel}
              onPaginationChange={setPaginationModel}
              total={total}
              loading={loading}
              filterModel={filterModel}
              onFilterChange={handleFilterModelChange}
              filterMode="server"
              isServerPagination={true}
            />
            {/* <DataGrid
              rows={legalFiles}
              columns={columns}
              getRowId={(row) => row.id}
              paginationModel={paginationModel}
              onPaginationModelChange={(newModel) => {
                setPaginationModel(newModel);
              }}
              onFilterModelChange={handleFilterModelChange}
              rowCount={total}
              paginationMode="server"
              pageSizeOptions={[10, 20, 50, 100]}
              loading={loading}
              disableRowSelectionOnClick
              showToolbar
              localeText={{
                ...toolbarLocaleText,
                footerRowSelected: () => "",
              }}
              slots={{
                toolbar: CustomToolbar,
              }}
            /> */}
          </Box>
      </Grid>
    </Grid>
  );
}
